var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9219 2.71612L26.7008 0.874023L28.0823 1.45819L27.3034 3.30029L25.9219 2.71612ZM1.54043 0.879223L0.157227 1.45953L0.93097 3.3038L2.31417 2.72349L1.54043 0.879223ZM10.9301 27.1904L9.26007 23.2104L10.6401 22.6304L12.3101 26.6104L10.9301 27.1904ZM7.59009 19.2404L5.92007 15.2604L7.30008 14.6804L8.97009 18.6604L7.59009 19.2404ZM4.25009 11.2904L2.58008 7.31039L3.96008 6.7304L5.63007 10.7104L4.25009 11.2904ZM13.3696 33.0104H14.7496L15.5296 31.1704L14.1496 30.5804L14.0696 30.7904L13.9796 30.5804L12.5996 31.1604L13.3696 33.0104ZM17.2198 27.1904L15.8398 26.6104L17.5198 22.6304L18.8998 23.2104L17.2198 27.1904ZM20.5898 19.2304L19.2098 18.6504L20.8898 14.6704L22.2698 15.2504L20.5898 19.2304ZM23.9598 11.2704L22.5798 10.6904L24.2598 6.71039L25.6398 7.2904L23.9598 11.2704Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerV);
export default __webpack_public_path__ + "static/media/LOWER_V.8562f4be3d079ccc07d5e035fff8c865.svg";
export { ForwardRef as ReactComponent };